import { REPORTING_STORE_ORDER_FIELDS } from '@tempo-io/reporting-store-dto';
import * as React from 'react';
import { useFlag } from '@/common/hooks/feature-flags/useFlag';
import { withoutPlannerModuleOrderKeys } from '@/features/items/components/table/columns/sortableItemFields';

export const useSortableItemFields = (): {
  sortableItemFields: ReadonlySet<string>;
} => {
  const plannerModuleEnabled = useFlag('plannerModuleEnabled');
  const sortableItemFields = React.useMemo(
    () => withoutPlannerModuleOrderKeys(REPORTING_STORE_ORDER_FIELDS, plannerModuleEnabled),
    [plannerModuleEnabled],
  );
  return { sortableItemFields };
};
